import { connect } from "react-redux";

// Constants
import { sections } from "src/constants";
import { surveyOptionsConfiguration } from "src/constants/filters_configurations/survey";

// Component
import { CheckboxFilterComponent } from "src/components/filters";

// UI Processors
import { createSectionSelectors } from "src/ui_processors/global/selector_creators";
import { createSectionActions } from "src/ui_processors/global/action_creators";

const sectionSelectors = createSectionSelectors(sections.survey);
const sectionActions = createSectionActions(sections.survey);

function mapStateToProps(state) {
  return {
    filterConfig: surveyOptionsConfiguration,
    filterCheckedState: sectionSelectors.createFilterCheckedStateSelector(
      surveyOptionsConfiguration
    )(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    selectCheckbox: filterObject => {
      dispatch(sectionActions.selectCheckbox(filterObject));
    },
    deselectCheckbox: filterObject => {
      dispatch(sectionActions.deselectCheckbox(filterObject));
    }
  };
}

export const SideBarSurveyOptionsFilterContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(CheckboxFilterComponent);
